import * as React from 'react';
import Typography from '@mui/material/Typography';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

const LinkBox = ({ links }) => {

  const [link, setLink] = React.useState('')

  const handleChange = (event) => {
    setLink(event.target.value);
    if (event.target.value !== '') {
      window.open(event.target.value);
    }

  };

  if (!links) {
    return null;
  }



  return (
    <div>
      <FormControl sx={{ m: 1, minWidth: 120 }} variant="standard">
        <Select
          value={link}
          onChange={handleChange}
          displayEmpty
          inputProps={{ 'aria-label': 'Without label' }}
        >
          <MenuItem value="">
            <Typography variant="subtitle2">업무용 사이트</Typography>
          </MenuItem>
          {links.map((item, index) => (
            // <a key={index} href={item.revVal2} target="_blank" rel="noreferrer">
            //   <MenuItem value={item.revVal2}>{item.revVal1}</MenuItem>
            // </a>

            <MenuItem key={index} value={item.revVal2}><Typography variant="subtitle2">{item.revVal1}</Typography></MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  )
}

export default LinkBox